import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import FormField from "../../../utils/FormField";
import { createUser } from "../../../redux/actions/user_actions.js";
import { update, generateData, ifFormValid } from "../../../utils/FormAction";
import { getProvinces, getDistricts, getWards } from "../../../redux/actions/user_actions";
import { getCategories } from "../../../redux/actions/products_actions";
import firebase from "../../../utils/Firebase";
import { withRouter, Link } from "react-router-dom";
import {
    Button,
    Card,
    Form,
    Container,
    Row,
    Col,
  } from "reactstrap";
import Select from 'react-select';
import { HOST_URL } from "../../../utils/misc.js";
import Swal from 'sweetalert2'

const Register = (props) => {
  //Status State
  const statusState = {
      isSuccessOtp: false,
      disabled: false,
      title: "Nhận mã xác thực OTP"
  }
  const [status, setStatus] = useState(statusState);
  const [province, setProvince] = useState(null)
  const [district, setDistrict] = useState(null)
  const [ward, setWard] = useState(null)
  const [provinces, setProvinces] = useState([])
  const [districts, setDistricts] = useState([])
  const [wards, setWards] = useState([])  

  const state = {
    formError: false,
    formSuccess: "",
    formData: {
        fullName: {
            element: "input",
            value: "",
            config: {
                name: "fullname_input",
                type: "text",
                placeholder: "Họ tên...",
            },
            validation: {
                required: true,
            },
            valid: false,
            touched: false,
            validationMessage: "",
        },
        birthDate: {
            element: "input",
            value: new Date(),
            config: {
                name: "birthday_input",
                type: "date",
                placeholder: "Ngày sinh...",
            },
            validation: {
                required: true
            },
            valid: false,
            touched: false,
            validationMessage: "",
        },
        address: {
            element: "input",
            value: "",
            config: {
                name: "address_input",
                type: "text",
                placeholder: "Địa chỉ...",
            },
            validation: {
                required: true
            },
            valid: false,
            touched: false,
            validationMessage: "",
        },
        email: {
            element: "input",
            value: "",
            config: {
                name: "email_input",
                type: "email",
                placeholder: "Email...",
            },
            validation: {
                required: true,
                email: true,
            },
            valid: false,
            touched: false,
            validationMessage: "",
        },
        password: {
        element: "input",
        value: "",
        config: {
            name: "password_input",
            type: "password",
            placeholder: "Mật khẩu...",
        },
        validation: {
            required: true,
            length: true,
        },
        valid: false,
        touched: false,
        validationMessage: "",
        },
        confirmPassword: {
            element: "input",
            value: "",
            config: {
              name: "confirm_password_input",
              type: "password",
              placeholder: "Nhập lại mật khẩu...",
            },
            validation: {
              required: true,
              confirm: "password",
            },
            valid: false,
            touched: false,
            validationMessage: "",
        },
        category: {
          element: "select",
          value: "",
          config: {
            name: "category_input",
            type: "number",
            placeholder: "Loại sản phẩm...",
            options: []
          },
          validation: {
            required: true
          },
          valid: false,
          touched: false,
          validationMessage: "",
        },
        identityNumber: {
            element: "input",
            value: "",
            config: {
              name: "identity_number_input",
              type: "number",
              placeholder: "Chứng minh thư...",
            },
            validation: {
              required: true
            },
            valid: false,
            touched: false,
            validationMessage: "",
        },
        dateRange: {
            element: "input",
            value: new Date(),
            config: {
                name: "date_range_input",
                type: "date",
                placeholder: "Ngày cấp...",
            },
            validation: {
                required: true
            },
            valid: false,
            touched: false,
            validationMessage: "",
        },
        issuePlace: {
            element: "input",
            value: "",
            config: {
              name: "issue_place_input",
              type: "text",
              placeholder: "Nơi cấp...",
            },
            validation: {
              required: true
            },
            valid: false,
            touched: false,
            validationMessage: "",
        },
        homePhone: {
            element: "input",
            value: "",
            config: {
              name: "home_phone_input",
              type: "number",
              placeholder: "Số điện thoại...",
              disabled: status.disabled
            },
            validation: {
              required: true
            },
            valid: false,
            touched: false,
            validationMessage: "",
        }
    },
  };

  const [input, setInput] = useState(state)

  useEffect(() => {
    props.dispatch(getProvinces()).then(res => {
      if(res.payload) {
        if(res.payload.provinces) {
          setProvinces(res.payload.provinces)
        }
      }
    })
    props.dispatch(getCategories()).then(res => {
      if(res.payload) {
        if(res.payload.categories) {
          let input = state
          input.formData.category.config.options = res.payload.categories
          setInput(input)
        }
      }
    })
  }, [])

  const updateForm = async (element) => {
    const newFormData = update(element, input.formData, "login");
    const newFormData_Input = {
      formError: false,
      formData: newFormData,
    };
    await setInput(newFormData_Input);
  };

  const submitForm = async (event) => {
    event.preventDefault();
    let dataToSubmit = generateData(input.formData, "login");
    if(dataToSubmit) {
      dataToSubmit.provinceId = province
      dataToSubmit.districtId = district
      dataToSubmit.wardId = ward
    } 
    let formIsValid = ifFormValid(input.formData, "login");  
    //Check none data
    if(!province || !district || !ward || dataToSubmit.address == "" || dataToSubmit.birthDate == "" || dataToSubmit.email == "" || dataToSubmit.fullName == "" 
      || dataToSubmit.password == "" || dataToSubmit.homePhone == "" || dataToSubmit.category == "" || dataToSubmit.identityNumber == "" || dataToSubmit.dateRange == "" || dataToSubmit.issuePlace == "") {
      return(
        Swal.fire({
          title: 'Vui lòng điền đủ thông tin',
          text: '',
          icon: 'warning',
          confirmButtonText: 'Đóng',
          confirmButtonColor: '#000000',
        }
        ) 
      )
    }
    else if(status.isSuccessOtp == false) {
      return(
        Swal.fire({
          title: 'Vui lòng xác thực sđt',
          text: '',
          icon: 'warning',
          confirmButtonText: 'Đóng',
          confirmButtonColor: '#000000',
        }
        ) 
      )
    }

    if (formIsValid && status.isSuccessOtp) {
      props.dispatch(createUser(dataToSubmit)).then((res) => {
        if (res.payload) {
          console.log(res.payload)
          if(res.payload.result.success == false || res.payload.result.code == '409'){
            return(
              Swal.fire({
                title: 'Đăng ký thất bại!',
                text: 'Tài khoản đã tồn tại',
                icon: 'error',
                confirmButtonColor: '#000000',
              }
              ).then((ok)=>{
                  if(ok){
                    props.history.push("/register")
                  }
              })
            )
          }
          else {
            Swal.fire({
              title: 'Đăng ký thành công!',
              text: 'Trở về đăng nhập',
              icon: 'success',
              confirmButtonText: 'Đóng',
              confirmButtonColor: '#000000',
            }
            ).then((ok)=>{
                if(ok){
                  props.history.push("/login")
                }
            })   
          }
        } 
        else {
          setInput((preState) => ({
            ...preState,
            formError: true,
          }));
          Swal.fire({
            title: 'Đăng ký thất bại!',
            text: 'Vui lòng thử lại',
            icon: 'error',
            confirmButtonText: 'Đóng',
            confirmButtonColor: '#000000',
          }
          ).then((ok)=>{
              if(ok){
                props.history.push("/login")
              }
          })
        }
      });
    } 
    else {
      await setInput((preState) => ({
        ...preState,
        formError: true,
      }));
    }
  };

  const handleAuthentication = () => {
    // let statusStateUpdate = {
    //     isSuccessOtp: true,
    //     disabled: true,
    //     title: "✔ Đã xác thực sđt"
    // }
    // setStatus(statusStateUpdate)

    // console.log("+84" + input.formData.phone.value)

    if(status.isSuccessOtp == false && input.formData.homePhone.value != ""){
        //Update state otp 
        let statusOtpUpdate = {
          isSuccessOtp: false,
          disabled: true,
          title: "Chờ xác thực sđt"
        }
        setStatus(statusOtpUpdate)

        window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier("recaptcha-container",
        {
           size:"invisible"
        });
        
        var phoneNumber = "+84" + input.formData.homePhone.value
        var appVerifier = window.recaptchaVerifier;
        firebase.auth().signInWithPhoneNumber(phoneNumber, appVerifier)
            .then(function (confirmationResult) {
                Swal.fire({
                    title: "Xác nhận OTP",
                    text: "Mã OTP đã được gửi, vui lòng chờ trong giây lát",
                    input: 'text',
                    showCancelButton: true ,
                    confirmButtonColor: '#000000',
                    confirmButtonText: 'Ok',
                    cancelButtonColor: '#999897',
                    cancelButtonText: 'Đóng',
                    width: '350px'
                }).then((result) => {
                    let code = result.value
                    confirmationResult.confirm(code).then(function (result) {
                        // User signed in successfully.
                        var user = result.user;
                        Swal.fire({
                            title: 'Xác thực thành công',
                            text: '',
                            icon: 'success',
                            confirmButtonText: 'Đóng',
                            confirmButtonColor: '#000000',})
                            let statusStateUpdate = {
                                isSuccessOtp: true,
                                disabled: true,
                                title: "✔ Đã xác thực sđt"
                            }
                            setStatus(statusStateUpdate)
                    }).catch(function (error) {
                        Swal.fire({
                            title: 'Xác thực thất bại',
                            text: '',
                            icon: 'error',
                            confirmButtonText: 'Đóng',
                            confirmButtonColor: '#000000',
                        })
                        let statusStateUpdate = {
                          isSuccessOtp: false,
                          disabled: true,
                          title: "Nhận lại mã xác thực OTP"
                        }
                        setStatus(statusStateUpdate)
                    });
                    window.confirmationResult = confirmationResult;
                });
            }).catch(function (error) {
              Swal.fire({
                  title: 'Xác thực thất bại',
                  text: '',
                  icon: 'error',
                  confirmButtonText: 'Đóng',
                  confirmButtonColor: '#000000',
              })
              let statusStateUpdate = {
                isSuccessOtp: false,
                disabled: false,
                title: "Nhận lại mã xác thực OTP"
              }
              setStatus(statusStateUpdate)
            });
    }
  }

  const handleChangeProvince = (selectedProvince) => {
    if(selectedProvince) {
      setProvince(selectedProvince.value)
      props.dispatch(getDistricts(selectedProvince.value)).then(res => {
        if(res.payload) {
          if(res.payload.districts) {
            setDistricts(res.payload.districts)
          }
        } 
      })
    }
  }

  const handleChangeDistrict = (selectedDistrict) => {
    if(selectedDistrict) {
      setDistrict(selectedDistrict.value)
      props.dispatch(getWards(selectedDistrict.value)).then(res => {
        if(res.payload) {
          if(res.payload.wards) {
            setWards(res.payload.wards)
          }
        } 
      })
    }
  } 

  const handleChangeWard = (selectedWard) => {
    if(selectedWard) {
      setWard(selectedWard.value)
    }
  } 

  return (
    <>
    <div id="recaptcha-container"></div>
      <div
        className="section section-image section-login"
        style={{
          backgroundImage: `url(${HOST_URL}${props.templates.templates.templateProperties.image_registerpage})`, minHeight:950
        }}
      >
        <div className="container-fluid p-0">
          <Container style={{ marginTop:150 }}>
            <Row>
              <Col className="mx-auto" lg="6" md="6">
                <Card className="card-register">
                  <h3 className="title mx-auto">Đăng Ký</h3>
                  <Form className="register-form" onSubmit={(event) => submitForm(event)}>
                      <label>Họ tên</label>
                          <div>
                              <FormField
                              id={"fullName"}
                              formData={input.formData.fullName}
                              change={(element) => updateForm(element)}
                              />
                          </div>
                      <label>Ngày sinh</label>
                          <div style={{ color:"black" }}>
                              <FormField
                                  id={"birthDate"}
                                  formData={input.formData.birthDate}
                                  change={(element) => updateForm(element)}
                                  />
                          </div>
                      <label>Địa chỉ</label>
                          <div>
                              <FormField
                              id={"address"}
                              formData={input.formData.address}
                              change={(element) => updateForm(element)}
                              />
                          </div>
                          <div className="row mt-1">
                            <div className="col-md-4 col-xs-12 text-dark province">
                              <Select
                                placeholder="Tỉnh thành"
                                isSearchable
                                options = {provinces}
                                onChange= {handleChangeProvince} 
                                noOptionsMessage={() => 'Chưa chọn tỉnh'}
                                theme = { theme => ({
                                  ...theme,
                                  borderRadius: 5,
                                  colors: {
                                    ...theme.colors,
                                    primary: '#444444',
                                  }
                                })}
                                // styles = {{
                                //   control: base => ({
                                //     ...base,
                                //     border: province != null ? 0 : "2.5px solid #f6c130"
                                //   })
                                // }}
                              />
                            </div>
                            <div className="col-md-4 col-xs-12 text-dark district">
                              <Select
                                placeholder="Quận/Huyện"
                                isSearchable
                                options = {districts}
                                onChange = {handleChangeDistrict}
                                noOptionsMessage={() => 'Chưa chọn quận/huyện'}
                                theme = { theme => ({
                                  ...theme,
                                  borderRadius: 5,
                                  colors: {
                                    ...theme.colors,
                                    primary: '#444444',
                                  },
                                })}
                              />
                            </div>
                            <div className="col-md-4 col-xs-12 text-dark ward">
                              <Select
                                placeholder="Phường/Xã"
                                isSearchable
                                options = {wards}
                                onChange = {handleChangeWard}
                                noOptionsMessage={() => 'Chưa chọn phường/xã'}
                                theme = { theme => ({
                                  ...theme,
                                  borderRadius: 5,
                                  colors: {
                                    ...theme.colors,
                                    primary: '#444444',
                                  },
                                })}
                              />
                            </div>
                          </div>
                    
                      <label>Chứng minh thư</label>
                        <div>
                            <FormField
                                id={"identityNumber"}
                                formData={input.formData.identityNumber}
                                change={(element) => updateForm(element)}
                            />
                        </div>
                      <label>Ngày cấp</label>
                        <div>
                            <FormField
                                id={"dateRange"}
                                formData={input.formData.dateRange}
                                change={(element) => updateForm(element)}
                            />
                        </div>
                      <label>Nơi cấp</label>
                        <div>
                            <FormField
                                id={"issuePlace"}
                                formData={input.formData.issuePlace}
                                change={(element) => updateForm(element)}
                            />
                        </div>     
                      <label>Email</label>
                          <div>
                              <FormField
                              id={"email"}
                              formData={input.formData.email}
                              change={(element) => updateForm(element)}
                              />
                          </div>
                      <label>Mật khẩu</label>
                          <div>
                              <FormField
                                  id={"password"}
                                  formData={input.formData.password}
                                  change={(element) => updateForm(element)}
                              />
                          </div>
                      <label>Nhập lại mật khẩu</label>
                          <div>
                          <FormField
                              id={"confirmPassword"}
                              formData={input.formData.confirmPassword}
                              change={(element) => updateForm(element)}
                          />
                          </div>                 
                      <label>Loại sản phẩm quan tâm</label>
                        <div>
                          <FormField
                              id={"category"}
                              formData={input.formData.category}
                              change={(element) => updateForm(element)}
                          />
                        </div>
                      <label>Số điện thoại</label>
                          <div>
                              <FormField
                                  id={"homePhone"}
                                  formData={input.formData.homePhone}
                                  change={(element) => updateForm(element)}
                              />
                              <label className="optRequest" onClick={handleAuthentication}><h6 className="optRequest">{ status.title }</h6></label>
                          </div>
                    <Button
                      block
                      className="btn-round"
                      color="default"
                      type="button"
                      onClick={(event) => submitForm(event)}>
                      Xác Nhận
                    </Button>
                  </Form>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </div>{" "}
    </>
  );
}

const mapStateToProps = (state) => {
  return {
      user: state.user,
      templates: state.templates,
  };
};

export default connect(mapStateToProps)(withRouter(Register));